import { Mesh, MeshBasicMaterial, SphereGeometry } from 'three';

import { WidgetObject } from '@/types';

interface ISphereOptions {
  color?: string;
}

export class Sphere3d {
  /**
   * 创建一个 3D 球体
   * @param data [x, y, z, radius] three.js 坐标系
   * @param options 配置项
   */
  static create(data: WidgetObject['data'], options: ISphereOptions): Mesh<SphereGeometry, MeshBasicMaterial> {
    const [x, y, z, radius] = data;
    const { color = '#ffffff' } = options;

    const geometry = new SphereGeometry(radius, 32, 32);
    const material = new MeshBasicMaterial({ color });
    const sphere = new Mesh(geometry, material);

    sphere.position.set(x, y, z);
    sphere.userData = { ...options };

    return sphere;
  }
}
